const ImpedimentEnum = Object.freeze({
    DiscapacidadIntelectual: 0,
    ProblemaAudicion: 1,
    ProblemasHabla: 2,
    ImpedimentoVisual: 3,
    DisturbioEmocional: 4,
    ImpedimentosOrtopedicos: 5,
    OtrosImpedimentos: 6,
    ProblemasEspecificosAprendizaje: 7,
    SordoCiego: 8,
    ImpedimentosMultiples: 9,
    Autismo: 10,
    DanioCerebralPorTrauma: 11
});

export { ImpedimentEnum };